<div class="contacts-container mt-4">
        <div class="d-grid contacts-header">
            <div class="d-flex align-items-center contact-title-wrapper">
                <img src="assets/svg/money-icon.svg" width="20" class="contact-section-icon">
                <h3 class="text-semibold contact-title">Oportunidades</h3>
            </div>
            <div class="justify-self-end">
                <button class="action-btn primary">
                    Crear nuevo presupuesto
                </button>
            </div>
        </div>
    </div>